
import { Component, Prop, Vue } from "vue-property-decorator";
import { Action, Getter, Mutation, State } from "vuex-class";

@Component
export default class AboutHeader extends Vue {
  private isDark(){
    //if(this.$route.name=="Home" || this.$route.name=="CV"){
    return false;
  }
}

